<template>
  <div>
    <el-dialog :visible.sync="visibleSync" width="80%" :before-close="onClose">
      <el-row>
        <el-col :span="24">
          <h1>
            {{$t('Flujos de aprobación de riesgos')}}
            <small>{{$t('Editar')}}</small>
          </h1>
        </el-col>

        <el-col :span="12" :offset="12">
          <WorkflowCreateSteps :step="step"/>
          <br>
        </el-col>

        <el-col :span="24" class="centrar">
          <br>
          <el-button-group>
            <el-button v-if="step > 1" type="danger" @click.prevent="prev()" size="medium">{{$t('Regresar')}}</el-button>
            <el-button
              v-if="step < 3"
              type="primary"
              @click.prevent="next()"
              size="medium"
            >{{$t('Siguiente')}}</el-button>
          </el-button-group>
        </el-col>

        <el-col :span="24">
          <br>
          <WorkflowCreate v-if="workflow" :step="step" :workflow="workflow"/>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">{{$t('Cerrar')}}</el-button>
        <el-button
          type="primary"
          @click.prevent="submit()"
          size="medium"
        >Actualizar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import WorkflowCreateSteps from '@/components/workflows/WorkflowCreateSteps.vue';
import WorkflowCreate from '@/components/workflows/WorkflowCreate.vue';

export default {
  props: ['visibleSync', 'onClose', 'workflow', 'onAcept'],
  components: {
    WorkflowCreate,
    WorkflowCreateSteps,
  },
  data() {
    return {
      step: 1,
      _id: '',
    };
  },
  created() {},
  methods: {
    listWorkflows() {
      this.$router.push({ name: 'workflows' });
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    submit() {
      this._id = JSON.parse(JSON.stringify(this.workflow))._id;
      const self = this;
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      };
      delete this.workflow._id;
      axios
        .post(`/workflow/editar/${self._id}`, self.workflow, config)
        .then((response) => {
          if (response.status === 200) {
            self.onClose();
            self.onAcept();
            self.step = 1;
          } else {
            console.log('error');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.centrar {
  text-align: center;
}
</style>
